import React, { useMemo, useState, forwardRef, useImperativeHandle } from 'react'
import { Button, Row, Upload, message as $message, Spin } from 'antd'
import CustomIcon from '@/components/CustomIcon'
import uploadToAliOss from '@/components/Uploader/ajax'
import TaskProgress from './TaskProgress'
import styles from './Dragger.less'
import LoadingOutlined from '@ant-design/icons/LoadingOutlined'

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />

const UploadContent = forwardRef(
    (
        {
            fileDirectory,
            isTranscoder,
            showSkip = true,
            onUploadFinish,
            onAllFinish,
            getProgressFunc,
            showProgress,
            content = () => {},
            onCancel = () => {}
        },
        ref
    ) => {
        const [taskId, setTaskId] = useState('')
        const [step, setStep] = useState(1)
        const [errorMsg, setErrorMsg] = useState('')

        const reset = () => {
            setTaskId('')
            setStep(1)
            setErrorMsg('')
        }

        useImperativeHandle(ref, () => ({
            reset,
            step
        }))

        const uploadProps = useMemo(
            () => ({
                name: 'file',
                accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                multiple: false,
                customRequest({ file, onProgress, onSuccess, onError }) {
                    return uploadToAliOss({
                        file,
                        fileDirectory,
                        isTranscoder,
                        temp: true,
                        onProgress,
                        onSuccess,
                        onError
                    })
                },
                showUploadList: false,
                beforeUpload(file) {
                    if (file?.size > 1024 * 3 * 1024) {
                        $message.error('大小不超过3MB')
                        return false
                    }
                },
                async onChange(info) {
                    const { event } = info
                    const { status, response } = info.file

                    if (event) {
                        if (event.percent === 0) {
                            setStep(2)
                        }
                        return
                    }
                    if (status === 'done') {
                        if (response && response.url) {
                            const data = await onUploadFinish(response)
                            if (data?.taskId) {
                                setTaskId(data.taskId)
                                setStep(3)
                            } else {
                                setErrorMsg(data.message)
                            }
                        } else {
                            setErrorMsg(response.message)
                            $message.error('上传失败')
                        }
                        return
                    }
                }
            }),
            [onUploadFinish]
        )


        if (step === 1) {
            return (
                <div className={styles.container}>
                    <Upload.Dragger className={styles.uploadWrap} {...uploadProps}>
                        <p className="ant-upload-drag-icon" style={{ paddingTop: '10px' }}>
                            <CustomIcon type="icon-shangchuan" className={styles.icon} style={{ fontSize: '60px' }} />
                        </p>
                        <p className="ant-upload-text">将Excel文件拖拽至框内上传</p>
                        <p className="ant-upload-hint">只能上传xlsx格式的Excel文件，大小不超过3MB</p>
                        <p className="ant-upload-btn" style={{ paddingTop: '20px', paddingBottom: '20px' }}>
                            <Button type="primary">上传文件</Button>
                        </p>
                    </Upload.Dragger>
                </div>
            )
        }

        if (step === 2) {
            return (
                <div className={styles.container}>
                    <div className={styles.uploadWrap}>
                        <Spin
                            indicator={errorMsg ? <div /> : antIcon}
                            style={{ paddingTop: '70px', marginBottom: '10px' }}
                        />
                        {errorMsg ? (
                            <div style={{ color: '#ff4d4f' }}>{errorMsg}</div>
                        ) : (
                            <div>文件处理中，请稍后...</div>
                        )}
                    </div>
                </div>
            )
        }
        if (step === 3 && taskId) {
            return (
                <div>
                    <div className={styles.container}>
                        <TaskProgress
                            id={taskId}
                            content={typeof content === 'function' ? content : content}
                            onFinish={onAllFinish}
                            getProgressFunc={getProgressFunc}
                            showProgress={showProgress}
                        />
                    </div>
                    {showSkip && (
                        <Row className="mt-20" justify="end">
                            <Button onClick={onCancel}>跳过等待</Button>
                        </Row>
                    )}
                </div>
            )
        }
        return null
    }
)
export default UploadContent
